import { useState } from "react";

import { useApiariesStore } from "entities/apiaries";
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import { UnionIcon } from "shared/ui/icons";
import { COLORS } from "shared/consts";
import { useDiaryStore } from "entities/diary";
import { format } from "date-fns";
import { useResize } from "app/lib/hooks/useResize";

export const DiaryTitleRight = () => {
    const currentApiaryId = useApiariesStore((s) => s.currentApiaryId);
    const exportTable = useDiaryStore(s => s.exportTable)
    const [isLoading, setIsLoading] = useState(false);

    const {isScreenMd} = useResize()

    const handleExport = async () => {
      if (!currentApiaryId || isLoading) return;
      setIsLoading(true);
      const blob = await exportTable(currentApiaryId);
      if (blob) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const filename = `Выгрузка записей журнала пчеловода от ${format(new Date(), 'dd.MM.yyyy, hh:mm')}.xlsx`;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      }
      setIsLoading(false);
    };

    return (
        <Button 
          label={isScreenMd ? (isLoading ? "Выгрузка..." : "Выгрузить") : ''}
          iconPrefix={<UnionIcon fill={COLORS.NEUTRAL.MUTED} />}
          variant="ghost"
          colorScheme="neutral"
          onClick={handleExport}
          disabled={isLoading}
        />
    );
};

